import { useLeadForm } from "../../hooks/useLeadForm";

/**
 * LeadForm — presentation. All state, validation, submit lives in useLeadForm.
 * When `compact` is true, drops the header block for use inside cards / sidebars.
 */
export default function LeadForm({
  category = "general",
  sourcePage = "unknown",
  compact = false,
  defaultConcern = "",
}) {
  const { form, set, loading, submit } = useLeadForm({ category, sourcePage, defaultConcern });

  return (
    <form onSubmit={submit} className={`space-y-3 ${compact ? "" : "card-soft p-6 md:p-8"}`} data-testid="lead-form">
      {!compact && (
        <>
          <div className="eyebrow">Talk to a physiotherapist</div>
          <h3 className="text-2xl md:text-3xl font-heading">Tell us what's troubling you</h3>
          <p className="text-sm text-brand-ink2 pb-2">
            Share a few details and our team will reach out — usually within a few hours.
          </p>
        </>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          data-testid="lead-name"
          className="w-full rounded-xl border border-black/10 px-4 py-3 bg-white text-brand-ink focus:outline-none focus:border-brand-blue"
          placeholder="Your name"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
        />
        <input
          data-testid="lead-phone"
          className="w-full rounded-xl border border-black/10 px-4 py-3 bg-white text-brand-ink focus:outline-none focus:border-brand-blue"
          placeholder="Mobile number"
          value={form.phone}
          onChange={(e) => set("phone", e.target.value)}
        />
      </div>

      <textarea
        data-testid="lead-concern"
        className="w-full rounded-xl border border-black/10 px-4 py-3 bg-white text-brand-ink focus:outline-none focus:border-brand-blue min-h-[90px]"
        placeholder="What's troubling you? (optional)"
        value={form.concern}
        onChange={(e) => set("concern", e.target.value)}
      />

      <input
        data-testid="lead-preferred-time"
        className="w-full rounded-xl border border-black/10 px-4 py-3 bg-white text-brand-ink focus:outline-none focus:border-brand-blue"
        placeholder="Preferred day / time (optional)"
        value={form.preferred_time}
        onChange={(e) => set("preferred_time", e.target.value)}
      />

      <label className="flex items-start gap-2 text-xs text-brand-ink2">
        <input
          type="checkbox"
          data-testid="lead-consent"
          checked={form.consent}
          onChange={(e) => set("consent", e.target.checked)}
          className="mt-1"
        />
        <span>I agree to be contacted by Physio Hyve regarding my enquiry.</span>
      </label>

      <button disabled={loading} data-testid="lead-submit" className="btn-primary w-full justify-center">
        {loading ? "Sending…" : "Request Callback"}
      </button>
    </form>
  );
}
